import { render } from "./NavigationCard.vue?vue&type=template&id=22fb44ea"
import script from "./NavigationCard.vue?vue&type=script&lang=js"
export * from "./NavigationCard.vue?vue&type=script&lang=js"

import "./NavigationCard.vue?vue&type=style&index=0&id=22fb44ea&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__